import { ChangeDetectionStrategy, Component, TemplateRef, ViewEncapsulation, computed, contentChild, forwardRef, input, viewChild } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { SelectButtonConfig } from "./selectButton.config";
import { CommonModule } from "@angular/common";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { SelectButtonModule } from "primeng/selectbutton";
import { Option } from "src/util/types/global";
import { GcLayoutModule } from "src/app/components/v-layout/layout.module";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";
import { VIconComponent } from "src/app/components/v-icon/v-icon.component";

@Component({
    selector:      'v-selectButton',
    templateUrl:   './selectButton.component.haml',
    styleUrls:     ['./selectButton.component.sass', '../input.style.sass'],
    encapsulation: ViewEncapsulation.None,
    providers:     [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VSelectButtonComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VSelectButtonComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VSelectButtonComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      true,
    imports:         [CommonModule, SelectButtonModule, ReactiveFormsModule, GcLayoutModule, VIconComponent, TranslateModule]
})
export class VSelectButtonComponent<T = unknown> extends InputFormWrapper<SelectButtonConfig, string> {

    protected readonly _baseConfig: SelectButtonConfig = SelectButtonConfig.baseTheme.Default;
    private readonly defaultTemplate = viewChild<TemplateRef<unknown>>('defaultTpl');
    private readonly externalTemplate = contentChild<TemplateRef<unknown>>('item');

    public readonly itemTemplate = computed(() => this.externalTemplate() ?? this.defaultTemplate());
    public readonly options = input<Option<T>[]>();
}